import { useMemo } from "react";
import {
  Chart as ChartJS, CategoryScale, LinearScale, PointElement,
  LineElement, Filler, Tooltip, Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

const MONTHS_EN    = ["January","February","March","April","May","June","July","August","September","October","November","December"];
const MONTHS_SHORT = ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"];

const PALETTE = [
  "#004a33","#fc8f04","#2980b9","#e74c3c","#8e44ad",
  "#16a085","#f39c12","#2c3e50","#27ae60","#c0392b",
  "#1abc9c","#d35400",
];

export function OrdersByType({ typesSold, height = "250px" }) {
  const datasets = useMemo(() => {
    return (typesSold || []).map((item, i) => {
      const color = PALETTE[i % PALETTE.length];
      const monthlyData = MONTHS_EN.map(month => {
        const found = item.monthly_data?.find(d => d.month === month);
        return found ? found.total_paid : 0;
      });
      return {
        label: item.product_type_name,
        data: monthlyData,
        borderColor: color,
        backgroundColor: color.replace("#", "rgba(").replace(/^rgba\(/, "rgba(") + "1A",
        borderWidth: 2,
        tension: 0.4,
        fill: true,
        pointRadius: 3,
        pointHoverRadius: 5,
      };
    });
  }, [typesSold]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    plugins: {
      legend: {
        position: "top",
        labels: { font: { size: 11 }, usePointStyle: true, pointStyleWidth: 8, padding: 12, color: "#718096" },
      },
      tooltip: {
        backgroundColor: "rgba(0,0,0,.82)",
        titleFont: { size: 12, weight: "600" },
        bodyFont: { size: 11 },
        padding: 10,
        cornerRadius: 8,
        callbacks: {
          label: ctx => ` ${ctx.dataset.label}: ${parseFloat(ctx.raw).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}`,
        },
      },
    },
    scales: {
      x: { grid: { color: "rgba(0,0,0,.04)" }, ticks: { font: { size: 10 }, color: "#a0aec0" } },
      y: {
        grid: { color: "rgba(0,0,0,.04)" },
        ticks: { font: { size: 10 }, color: "#a0aec0", callback: v => `R$${(v / 1000).toFixed(0)}k` },
        beginAtZero: true,
      },
    },
  };

  const data = { labels: MONTHS_SHORT, datasets };

  return (
    <div style={{ height, width: "100%", position: "relative" }}>
      <Line options={options} data={data} />
    </div>
  );
}
